import { render } from "./PresentationChatRDG.vue?vue&type=template&id=3313b840"
const script = {}

import "./PresentationChatRDG.vue?vue&type=style&index=0&id=3313b840&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__